import { SelecaoComFiltro } from "app/components/selecao-com-filtro/SelecaoComFiltro";
import { ICidade } from "app/types/ICidade";
import ValidarInscricaoSuframa, { ICliente } from "app/types/ICliente";
import { IEstado } from "app/types/IEstado";
import { ISegmento } from "app/types/ISegmento";
import { IVendedor } from "app/types/IVendedor";
import clsx from "clsx";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useCallback, useEffect, useState } from "react";
import { Bairro } from "../../../types/NovoEndereco";
import validaCpfCnpj from "../../../utils/validarCpfCnpj";
import { InputCep } from "../../inputs/InputCep";
import { InputCpfCnpj } from "../../inputs/InputCpfCnpj";
import { InputTelefoneCelular } from "../../inputs/InputTelefoneCelular";
import { InputData } from "app/components/inputs/InputData";
import { IEndereco } from "app/types/IEndereco";
import debounce from "lodash/debounce";
import orcamentoConcluidoStories from "app/components/itens-orcamento/orcamento-concluido/orcamentoConcluido.stories";

const estilosInputs = require("../../../estilos/inputs.module.scss").default;
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;

export type DadosBasicosClienteProps = {
  somenteLeitura: boolean
  foraOrcamento?: boolean // 414608
  tipoOrcamento?: 0 | 1 | 2 | 3; // 414608
  permiteEditarCpfCnpj: boolean
  cliente: ICliente;
  vendedores: IVendedor[];
  bairros: Bairro[];
  uf: IEstado[];
  cidades: ICidade[];
  segmentos: ISegmento[];
  utilizarVendedorRelacionado: boolean;
  utilizarBairrosPreCadastrados: boolean
  permitirAlterarDadosBasicos: boolean;
  permiteAlterarNomeRazaoSocial: boolean
  usuarioPermitidoAlterarVendedorRelacionado: boolean;
  usaClienteMais: string
  formularioValidado: boolean;
  permiteEditarEnderecoComercial: boolean // 465680
  //493933 ocultarCelularEContato?: boolean // 490808 - aba "Dados Cliente" é dona desses campos (I2)
  paramTRABALHA_COBRANCA_PIX_PRAZO?: boolean // 414608 pixPrazo
  onPesquisarVendedorRelacionado: (nomeVendedorRelacionado: string) => void;
  onPesquisarCep: (cep: string, cliente: ICliente) => void;
  onListarCidadesPorEstado: (codigoEstado: number) => void;
  onListarBairros: (bairro: string) => void;
  manterDadosTemporarios: (cliente: ICliente) => void;
  onErrorValidacao: (erroDadosBasicos: FormikErrors<ICliente>) => void
  onValidarFormulario: (formularioValidado: boolean) => void
  onAlteradoCPFCNPJ: (cpfCnpj: string) => void
  onAlterarEnderecoComercial: (endereco: IEndereco) => void
  onAlterarEmailPixPrazoNoOrcamento: (emailPixPrazo: string) => void // 414608
};


export const DadosBasicosCliente = (props: DadosBasicosClienteProps) => {
  const [pesquisadoCep, setPesquisadoCep] = useState(false);
  const [carregandoBairro, setCarregadoBairro] = useState(false)
  const [alteradoCpfCnpj, setAlteradoCpfCnpj] = useState(false)

  const formik = useFormik({
    initialValues: { ...props.cliente },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => {
      const erroSuframa = ValidarInscricaoSuframa(values.InscricaoSuframa) // 462219

      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`;
      return R.pickBy((val) => globalMU.isNotNullOrEmpty(val), {
        CpfCnpj: !values.CpfCnpj ? mensagemObrigatorio("CPF/CNPJ") : !validaCpfCnpj(values.CpfCnpj ?? "") ? "O campo CPF/CNPJ é inválido" : undefined,
        Nome: !values.Nome && props.permitirAlterarDadosBasicos ? mensagemObrigatorio("Nome") : undefined,
        Telefone: !values.Telefone && values.TelefoneObrigatorio ? mensagemObrigatorio("Telefone") : undefined,
        Celular: !values.Celular && (values.CelularObrigatorio || values.ReceberNotificacaoWhatsapp) ? mensagemObrigatorio("Celular") : undefined, 
        Cep: !values.Cep && props.permitirAlterarDadosBasicos ? mensagemObrigatorio("Cep") : undefined,
        Endereco: !values.Endereco ? mensagemObrigatorio("Logradouro") : undefined,
        Bairro: !values.Bairro ? mensagemObrigatorio("Bairro") : undefined,
        CodigoEstado: !values.CodigoEstado ? mensagemObrigatorio("Uf") : undefined,
        CodigoCidade: !values.CodigoCidade ? mensagemObrigatorio("Cidade") : undefined,
        NumeroEndereco: !values.NumeroEndereco ? mensagemObrigatorio("Número") : undefined,
        Email: !values.Email && (values.EmailObrigatorio || values.ReceberNotificacaoEmail) ? mensagemObrigatorio("Email") : undefined,
        Segmento: values.CodigoSegmento <= 0 && values.SegmentoObrigatorio ? mensagemObrigatorio("Segmento") : undefined,
        VendedorRelacionado: !values.VendedorRelacionado && values.VendedorRelacionadoObrigatorio ? mensagemObrigatorio("Vend.Relacionado") : undefined,
        RazaoSocial: !values.RazaoSocial && values.PessoaJuridica ? mensagemObrigatorio("Razão Social") : undefined,
        InscricaoSuframa: values.InscricaoSuframa && erroSuframa.length > 0 ? erroSuframa : undefined, // 462219
      } as FormikErrors<ICliente>)
    }
  });


  const onEnviarDadosEndereco = (enderecoData: ICliente) => {
    props.onAlterarEnderecoComercial({
      Logradouro: enderecoData.Endereco,
      Cep: enderecoData.Cep,
      Numero: enderecoData.NumeroEndereco,
      CodigoEstado: enderecoData.CodigoEstado,
      Bairro: enderecoData.Bairro,
      CodigoCidade: enderecoData.CodigoCidade,
      NomeCidade: enderecoData.NomeCidade,
      Complemento: enderecoData.ComplementoEndereco,
      SiglaUf: enderecoData.SiglaUf,
      Referencia: enderecoData.Referencia,
      TipoPessoa: enderecoData.TipoPessoa,
    });
  };
  const onValidacaoFormularioVerdadeiro = useCallback(async () => {
    props.onValidarFormulario(true);
    props.onErrorValidacao(null);
  }, [props]);
  
  const onValidacaoFormaularioFalso = useCallback(async (erros: FormikErrors<ICliente>) => {
    props.onValidarFormulario(false);
    props.onErrorValidacao(erros);
  }, [props]);

  const onValidarDadosFormulario = async () => {
    const erros = await formik.validateForm(formik.values)
    Object.keys(erros).length == 0 ? onValidacaoFormularioVerdadeiro() : onValidacaoFormaularioFalso(erros);
  }

  useEffect(() => {
    setCarregadoBairro(false)
  }, [props.bairros])

  useEffect(() => {
    props.manterDadosTemporarios(formik.values);
    onValidarDadosFormulario()
  }, [formik.values]);


  const cpfCnpj = (
    <div>
      <label>
        CPF / CNPJ <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      </label>
      <InputCpfCnpj
        className={`_w-[200px] ${alteradoCpfCnpj && formik.errors.CpfCnpj != undefined && estilosInputs.inputComErro}`}
        name="CpfCnpj"
        id="dadosBasicosCliente_CpfCnpj"
        disabled={!props.permiteEditarCpfCnpj || props.somenteLeitura}
        cpfCnpj={formik.values?.CpfCnpj}
        onCpfCnpjModificado={useCallback(debounce((novoCpfCnpj) => {
          setAlteradoCpfCnpj(true);
          formik.setFieldValue("CpfCnpj", novoCpfCnpj);
          novoCpfCnpj != null && validaCpfCnpj(novoCpfCnpj) && props.onAlteradoCPFCNPJ(novoCpfCnpj);
        }, 300), [formik.values])}
        autoFocus
      />
    </div>
  );

  const handleChange = useCallback((event) => {
    
    formik.handleChange(event);
  }, [formik]);
  
  const nome = (
    <div>
      <label>
        Nome <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      </label>
      <input
        disabled={ props.somenteLeitura || (props.cliente.Codigo > 7 && (props.permitirAlterarDadosBasicos && props.permiteAlterarNomeRazaoSocial))}
        title="Veja segurança cliente:&#013;-Alteração de Nome/Razão Social"
        className={`_w-[360px] ${props.formularioValidado && formik.errors.Nome != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao}`}
        name="Nome"
        id="DadosBasicosCliente_CampoNome"
        autoComplete="off"
        value={formik.values?.Nome ?? ""}
        onChange={handleChange}
      />
    </div>
  );
  

  const razaoSocial = (
    <div>
      <label>
        Razão Social
        {formik.values.PessoaJuridica && (<p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>)}
      </label>
      <input
        disabled={props.somenteLeitura || !formik.values.PessoaJuridica || (props.cliente.Codigo > 7 && (props.permitirAlterarDadosBasicos && props.permiteAlterarNomeRazaoSocial))}
        className={`_w-[360px] ${estilosInputs.inputPadrao} ${formik.values.TipoPessoa == "J" && props.formularioValidado && formik.errors.RazaoSocial != undefined && estilosInputs.inputComErro}`}
        name="RazaoSocial"
        autoComplete="off"
        id="DadosBasicosCliente_CampoRazaoSocial"
        value={formik.values?.RazaoSocial ?? ""}
        onChange={handleChange}
      />
    </div>
  );

  const email = <div>
    <label>
      E-mail NF-e
      {formik.values.EmailObrigatorio && (
        <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      )}
    </label>
    <input
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      placeholder="Informe emails separados por ponto e vírgula"
      className={`_w-[280px] ${estilosInputs.inputPadrao} ${props.formularioValidado && formik.errors.Email != undefined && estilosInputs.inputComErro}`}
      name="Email"
      autoComplete="off"
      id="DadosBasicosCliente_CampoEmail"
      value={formik.values?.Email ?? ""}
      onChange={handleChange}
    />
  </div>

   const emailPixPrazo = <>
    <label
      title="Veja parâmetro: &#013;-PIX a Prazo: Trabalha com recebimento PIX a Prazo"
    >
      E-mail
    </label>
    <input
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      placeholder="Informe emails separados por ponto e vírgula"
      className={`_w-[280px] ${estilosInputs.inputPadrao} ${props.formularioValidado && formik.errors.Email != undefined && estilosInputs.inputComErro}`}
      style={{ maxHeight: "26px" }}
      autoComplete="off"
      id="DadosBasicosCliente_CampoEmailPixAPrazo"
      value={formik.values?.EmailPixAPrazo ?? ""}
      //onChange={handleChange}
      onChange={(e) => { 
        
        formik.setFieldValue("EmailPixAPrazo", e.target.value)
        if (!formik.values.EmailPixAPrazoOriginal){
          formik.setFieldValue("EmailPixAPrazoOriginal", "")
        }
        if (formik.values.EmailPixAPrazoOriginal == e.target.value){
          formik.setFieldValue("AtualizarEmailPixAPrazo", false)
        }
          
        handleChange(e)
      }}
      onBlur={e => { //414608
          formik.handleBlur(e)
          if (!globalMU.validateMultipleEmails(formik.values?.EmailPixAPrazo ?? "")){
            return
          }
          props.onAlterarEmailPixPrazoNoOrcamento( e.target.value)
      }}
     
    />
  </>
  const atualizarEmailPixPrazo = <>
    <label
      className={clsx("_cursor-pointer", { // 414608
          "_text-red-500": !formik.values?.AtualizarEmailPixAPrazo && 
                          formik.values?.EmailPixAPrazo !== formik.values?.EmailPixAPrazoOriginal
        })}
      id="DadosBasicosCliente_LabelAtualizarEmailPixAPrazo"
      style={{ maxHeight: "26px" }}
      title="Atualiza o campo [E-mail] quando gravar o cliente.&#013;Se não estiver marcado, a alteração do campo não será gravada&#013;&#013;Veja parâmetro: &#013;-PIX a Prazo: Trabalha com recebimento PIX a Prazo"
      htmlFor="DadosBasicosCliente_CampoAtualizarEmailPixAPrazo"
    >
      Atualizar E-mail no Cadastro do Cliente
    </label>
    <input
      type="checkbox"
      className="_mr-4"
      style={{ maxHeight: "26px", color: "red" }}
      disabled={props.somenteLeitura 
                  || !props.permitirAlterarDadosBasicos 
                  || formik.values?.EmailPixAPrazo == formik.values?.EmailPixAPrazoOriginal}
      id="DadosBasicosCliente_CampoAtualizarEmailPixAPrazo"
      checked={formik.values?.AtualizarEmailPixAPrazo ?? false}
      onChange={(e) => { 
        formik.setFieldValue("AtualizarEmailPixAPrazo", e.target.checked)
        handleChange(e)
      }}
    />
  </>
// 474612 const handleDateChange = useCallback((date) => {
//   formik.setFieldValue("DataNascimento", date);
// }, [formik]);

const dataNascimento = (
  <div className="_flex">
    <label>Data Nascimento</label>
    <InputData
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      id="DadosBasicosCliente_CampoDataNascimento"
      data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataNascimento)}
      //474612 onChange={handleDateChange}
      onChange={(e) => formik.setFieldValue("DataNascimento", e)}
      selecionaValorOnFocus
    />
  </div>
)


const handleTelefoneModificado = useCallback((novoTelefone) => {
  formik.setFieldValue("Telefone", novoTelefone);
}, [formik]);

const telefone = (
  <>
    <label
      id="DadosBasicosCliente_LabelTelefone"
      title="Veja parâmetros: &#013;-Telefone obrigatório no cadastro de cliente&#013;-Padrão de inclusão de telefone de cliente por filial &#013;-Padrão de inclusão de telefone de cliente&#013;-Endereço, telefone e segmento obrigatórios no cadastro de cliente"
    >
      Telefone
      {formik.values.TelefoneObrigatorio && (
        <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      )}
    </label>
    <InputTelefoneCelular
      id="DadosBasicosCliente_CampoTelefone"
      className={props.formularioValidado && formik.errors.Telefone != undefined ? estilosInputs.inputComErro : undefined}
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      placeholder="(99) 99999-9999"
      telefoneCelular={formik.values.Telefone}
      onTelefoneCelularModificado={handleTelefoneModificado}
    />
  </>
);


const handleCelularModificado = useCallback((novoCelular) => {
  formik.setFieldValue("Celular", novoCelular);
}, [formik]);

const celular = (
  <>
    <label
      id="DadosBasicosCliente_LabelCelular"
      title="Veja parâmetros: &#013;-Padrão de inclusão de celular de cliente por filial &#013;-Padrão de inclusão de celular de cliente"
    >
      Celular
      {formik.values.CelularObrigatorio && (
        <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      )}
    </label>
    <InputTelefoneCelular
      id="DadosBasicosCliente_CampoCelular"
      className={props.formularioValidado && formik.errors.Celular != undefined ? estilosInputs.inputComErro : undefined}
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      placeholder="(99) 99999-9999"
      telefoneCelular={formik.values.Celular}
      onTelefoneCelularModificado={handleCelularModificado}
    />
  </>
);


const handleCepModificado = useCallback((cep) => {
  formik.setFieldValue("Cep", cep);
  props.onPesquisarCep(cep, formik.values);
  setPesquisadoCep((prev) => !prev);
}, [formik, props]);

const cep = (
  <div>
    <label title="Veja parâmetro:&#013;-Obter endereço a partir do CEP">
      CEP <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <InputCep
      className={clsx(props.formularioValidado && formik.errors.Cep != undefined && estilosInputs.inputComErro, "_w-[100px]")}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null))}
      disabled={props.somenteLeitura || (
        formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )
    )}
      cep={formik.values.Cep}
      id="DadosBasicosCliente_CampoCep"
      onCepModificado={handleCepModificado}
      emitirComMascara
    />
  </div>
);


const handlePesquisarCep = useCallback(() => {
  props.onPesquisarCep(formik.values.Cep, formik.values);
  setPesquisadoCep(true);
}, [formik, props]);

const buttonPesquisaCep = (
  <>
    {!props.somenteLeitura && props.permitirAlterarDadosBasicos && (
      <button
        className={clsx('no-global-button', estilosBotoes.botaoPrimario)}
        disabled={props.somenteLeitura || (formik.values.Cep && pesquisadoCep || formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)))}
        id="DadosBasicosCliente_PesquisarCep"
        onClick={handlePesquisarCep}
      >
        Pesquisar CEP
      </button>
    )}
  </>
);


const handleEnderecoChange = useCallback((e) => {
  formik.setFieldValue("Endereco", e.target.value);
  onEnviarDadosEndereco({
    ...formik.values,
    Endereco: e.target.value,
  });
}, [formik, onEnviarDadosEndereco]);

const logradouro = (
  <>
    <label>
      Logradouro <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <input
      title="Veja Permissões de Segurança do Cliente&#013;Veja parâmetros:&#013;-Bloquear alteração do endereço de entrega do cliente (pessoa jurídica) no orçamento&#013;-Bloqueia edição de endereço de cobrança no orçamento"
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null))}
      disabled={formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )}
      className={`_w-[200px] ${props.formularioValidado && formik.errors.Endereco != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao}`}
      style={{ marginRight: "5px" }}
      name="Endereco"
      id="DadosBasicosCliente_CampoLogradouro"
      type="text"
      maxLength={254}      
      value={formik.values.Endereco ?? ""}
      onChange={handleEnderecoChange}
    />
  </>
);


  const numero = <div>
    <label>
      Número <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <input
      //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
      disabled={formik.values.Codigo > 7 
        && (( !props.permitirAlterarDadosBasicos   || !props.permiteEditarEnderecoComercial ) // 465680
          || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) 
        )} // 441453
      className={`_w-[100px] ${estilosInputs.inputPadrao} ${props.formularioValidado && formik.errors.NumeroEndereco != undefined && estilosInputs.inputComErro}`}
      maxLength={254}
      name="NumeroEndereco"
      id="DadosBasicosCliente_CampoNumero"
      value={formik.values?.NumeroEndereco ?? ""}
      onChange={(e) => {
        formik.setFieldValue("NumeroEndereco", e.target.value)
        onEnviarDadosEndereco({
          ...formik.values,
          NumeroEndereco: e.target.value,
        });
      }}
    />
  </div>

  const complemento = <div>
    <label>Complemento</label>
    <input
      //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
      disabled={formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )} // 441453
      className={`_w-[280px] ${estilosInputs.inputPadrao} `}
      maxLength={254}
      name="ComplementoEndereco"
      id="DadosBasicosCliente_CampoComplemento"
      value={formik.values?.ComplementoEndereco ?? ""}
      onChange={(e) => {
        formik.setFieldValue("ComplementoEndereco", e.target.value)
        onEnviarDadosEndereco({
          ...formik.values,
          ComplementoEndereco: e.target.value,
        });
      }}
    />
  </div>

  const bairro = <div>
    <label
      title="Veja parâmetro:&#013;-Utilizar no Orçamento bairros pré-cadastrados"
    >
      Bairro <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>

    {props.utilizarBairrosPreCadastrados ?
      <div className="_inline-flex">

        <SelecaoComFiltro
         // disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
          //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
          disabled={formik.values.Codigo > 7 
            && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
                || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
                )} // 441453
          classNameInput={`_w-[280px] ${props.formularioValidado && formik.errors.Bairro != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao} `}
          itens={carregandoBairro ? [{ chave: "", valor: "Buscando..." }] : !Array.isArray(props.bairros) ? [{ chave: "", valor: "Nenhum bairro encontrado..." }] : (props.bairros ?? []).map(bairro => ({
            chave: bairro.Codigo.toString(),
            valor: bairro.Nome
          }))}
          onValorModificado={(bairro) => {
            (setCarregadoBairro(true), props.onListarBairros(bairro))}
          }
          onItemSelecionado={item => {
            formik.setFieldValue("Bairro", (props?.bairros ?? []).find(b => b.Codigo.toString() == item.chave)?.Nome)
            onEnviarDadosEndereco({
              ...formik.values,
              Bairro: (props?.bairros ?? []).find(b => b.Codigo.toString() == item.chave)?.Nome,
            })
          }}
          itemSelecionado={{
            chave: Array.isArray(props.bairros) && (props?.bairros ?? []).find(b => b.Nome.toString() == formik.values.Bairro)?.Codigo.toString(),
            valor: formik.values.Bairro
          }}
          filtroManual={true}
          placeholder="Digite 1 ou mais caracteres"
        />

      </div>

      : <div className="_inline-flex">
        <input
          //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
          //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
          disabled={formik.values.Codigo > 7 
            && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
                || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
                )} // 441453
          className={`_w-[280px] ${props.formularioValidado && formik.errors.Bairro != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao} `}
          name="Bairro"
          id="DadosBasicosCliente_CampoBairro"
          value={formik.values?.Bairro ?? ""}
          onChange={formik.handleChange}
        />
      </div>}

  </div>

  const uf = <div>
    <label>
      U.F. <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <select
      className={`_w-[60px] ${props.formularioValidado && formik.errors.CodigoEstado != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao} `}
      //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
      disabled={formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )} // 441453
      name="CodigoEstado"
      value={(formik.values.CodigoEstado) ?? ""}
      multiple={false}
      onChange={(e) => {
        formik.setFieldValue("CodigoEstado", Number(e.target.value));
        onEnviarDadosEndereco({
          ...formik.values,
          CodigoEstado: Number(e.target.value),
          SiglaUf: props.uf?.find(x => x.Codigo == Number(e.target.value)).Sigla,
          CodigoCidade: null,
          NomeCidade: null
        });
        Number(e.target.value) != 0 &&
          props.onListarCidadesPorEstado(Number(e.target.value));
      }}
    >
      <option value="">Selecione</option>
      {props.uf?.map((value) => (
        <option
          key={value.Codigo}
          value={value.Codigo}
        >
          {value.Sigla}
        </option>
      ))}
    </select>
  </div>

  const cidade = <div>
    <label>
      Cidade <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <select
      //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
      disabled={formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )} // 441453
      multiple={false}
      name="CodigoCidade"
      value={(formik.values.CodigoCidade) ?? ""}
      onChange={(e) => {
        formik.setFieldValue("CodigoCidade", Number(e.target.value))
        formik.setFieldValue("NomeCidade", props.cidades.find(cidade => cidade.Codigo.toString() == e.target.value).Nome)
        onEnviarDadosEndereco({
          ...formik.values,
          CodigoCidade: Number(e.target.value),
          NomeCidade: props.cidades.find(cidade => cidade.Codigo.toString() == e.target.value).Nome
        });
      }}
      className={`_w-[280px] ${props.formularioValidado && formik.errors.CodigoCidade != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao} `}
    >
      <option value="">Selecione</option>
      {props.cidades?.map((value) => (
        <option
          key={value.Oid}
          value={value.Oid}
        >
          {value.Nome}
        </option>
      ))}
    </select>
  </div>

  const referencia = <div>
    <label>Referência</label>
    <input
      type="text"
      //disabled={!(props.permitirAlterarDadosBasicos && formik.values.PermitirEditarEndereco)}
      //disabled={formik.values.Codigo > 7 && (!props.permitirAlterarDadosBasicos || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null ) )} // 441453
      disabled={formik.values.Codigo > 7 
        && ( ( !props.permitirAlterarDadosBasicos || !props.permiteEditarEnderecoComercial ) // 465680
            || (!formik.values.PermitirEditarEndereco && formik.values.Enderecos != null)
            )} // 441453
      className={`${estilosInputs.inputPadrao} _w-[280px]`}
      name="Referencia"
      id="DadosBasicosCliente_CampoReferencia"
      maxLength={254}
      value={formik.values?.Referencia ?? ""}
      onChange={(e) => {
        formik.handleChange(e);
        onEnviarDadosEndereco({
          ...formik.values,
          Referencia: (e.target.value),
        });
      }}
    />
  </div>


  const inscricaoEstadual = <>
    <label>Inscrição Estadual</label>
    <input
      type="text"
      disabled={!props.permitirAlterarDadosBasicos}
      className={`${estilosInputs.inputPadrao} _w-[200px]`}
      name="InscricaoEstadual"
      id="DadosBasicosCliente_CampoInscricaoEstadual"
      value={formik.values?.InscricaoEstadual ?? ""}
      onChange={(e) => {
        formik.handleChange(e);
      }}
    />
  </>

  const contribuinte = <>
    <label className="_cursor-pointer" htmlFor="CadastroCliente_Contribuinte">Contribuinte</label>
    <input
      className="_w-[15px]"
      disabled={!props.permitirAlterarDadosBasicos}
      type="checkbox"
      name="Contribuinte"
      id="CadastroCliente_Contribuinte"
      onChange={(e) => {
        formik.handleChange(e);
      }}
      checked={formik.values.Contribuinte ?? false}
    />
  </>

  const incricaoSuframa = <>
    <label>Inscrição Suframa</label>
    <input
      type="text"
      disabled={!props.permitirAlterarDadosBasicos}
      className={`${estilosInputs.inputPadrao} _w-[200px]`}
      name="InscricaoSuframa"
      id="DadosBasicosCliente_CampoSufrana"
      value={formik.values?.InscricaoSuframa ?? ""}
      onChange={(e) => {
        formik.handleChange(e);
      }}
      onBlur={() => {
        const erro = ValidarInscricaoSuframa(formik.values?.InscricaoSuframa) // 462219
        if (erro.length > 0) {
          globalMU.showErrorMessage(erro)
        }
       }}
    />
  </>

  const ClienteAssociado = <>
    <label>Cliente Associado</label>
    <input
      type="text"
      disabled
      className={`${estilosInputs.inputPadrao} _w-[200px]`}
      name="ClienteAssociado"
      id="DadosBasicosCliente_CampoClienteAssociado"
      value={formik.values?.ClienteAssociado ?? ""}
    />
  </>

const handleSegmentoChange = useCallback((e) => {
  const selectedSegmento = props.segmentos.find(segmento => segmento.Codigo == Number(e.target.value));
  formik.setFieldValue("CodigoSegmento", Number(e.target.value));
  formik.setFieldValue("Segmento", selectedSegmento);
}, [formik, props.segmentos]);

const segmento = (
  <>
    <label>
      Segmento
      {formik.values.SegmentoObrigatorio && (
        <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      )}
    </label>
    <select
      disabled={!props.permitirAlterarDadosBasicos}
      multiple={false}
      name="Segmento"
      onChange={handleSegmentoChange}
      value={(formik.values.Segmento?.Codigo) ?? ""}
      className={`${props.formularioValidado && formik.errors.Segmento != undefined && estilosInputs.inputComErro} ${estilosInputs.inputPadrao} _w-[200px] `}
    >
      <option value="">Selecione</option>
      {props.segmentos?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Nome}
        </option>
      ))}
    </select>
  </>
);


  const vendedorRelacionado = <>
    <label
      title="Veja parâmetro:&#013;-Visualiza vendedor relacionado na consulta do cliente?&#013;-Permite alterar o vendedor relacionado, na consulta de clientes?"
      >
      Vendedor Relacionado
      {formik.values.VendedorRelacionadoObrigatorio && (
        <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
      )}
    </label>

    <SelecaoComFiltro
      disabled={!props.permitirAlterarDadosBasicos}
      classNameInput={`_w-[200px] ${props.formularioValidado && formik.errors.VendedorRelacionado != undefined ? estilosInputs.inputComErro : null}  ${estilosInputs.inputPadrao} `}
      itens={(props.vendedores ?? [])?.map(vendedor => ({
        chave: vendedor.Codigo.toString(),
        valor: vendedor.Nome
      }))}
      onValorModificado={(vendedor) => props.onPesquisarVendedorRelacionado(vendedor)}
      onItemSelecionado={item => {
        formik.setFieldValue("VendedorRelacionado", (props?.vendedores ?? []).find(b => b.Codigo.toString() == item.chave).Nome)
      }}
      itemSelecionado={{
        chave: formik.values.CodigoVendedorRelacionado?.toString(),
        valor: formik.values.VendedorRelacionado
      }}
      placeholder="Digite 1 ou mais caracteres"
    />
  </>


  const apelido = <>
    <label>Apelido</label>
    <input
      disabled={!props.permitirAlterarDadosBasicos}
      className={`${estilosInputs.inputPadrao} _w-[200px]`}
      name="Apelido"
      id="DadosBasicosCliente_CampoApelido"
      value={formik.values?.Apelido ?? ""}
      onChange={formik.handleChange}
    />
  </>

  const contato = <>
    <label>Nome Contato</label>
    <input
      disabled={!props.permitirAlterarDadosBasicos}
      className={`${estilosInputs.inputPadrao} _w-[200px]`}
      name="Contato"
      id="DadosBasicosCliente_CampoNomeContato"
      value={formik.values?.Contato ?? ""}
      onChange={formik.handleChange}
    />
  </>

  const clienteChatubaMais = <div>
    <label htmlFor="CadastroCliente_ClienteMais">{props.usaClienteMais}</label>
    <input
      type="checkbox"
      name="ClienteMais"
      id="CadastroCliente_ClienteMais"
      onChange={(e) => {
        formik.handleChange(e);
      }}
      disabled
      checked={formik.values.ClienteMais ?? false}
    />
  </div>

  const receberNotificacaoWhatsapp = <div>
    <label
      className="_cursor-pointer"
      htmlFor="DadosBasicosCliente_ReceberNotificacaoWhatsapp"
      title="Quando marcado, o celular é obrigatório."
    >
      Receber Notificação Via Whatsapp
    </label>
    <input
      type="checkbox"
      name="ReceberNotificacaoWhatsapp"
      id="DadosBasicosCliente_ReceberNotificacaoWhatsapp"
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      checked={formik.values?.ReceberNotificacaoWhatsapp === true}
      onChange={(e) => {
        formik.setFieldValue("ReceberNotificacaoWhatsapp", e.target.checked)
      }}
    />
  </div>

  const receberNotificacaoEmail = <div>
    <label
      className="_cursor-pointer"
      htmlFor="DadosBasicosCliente_ReceberNotificacaoEmail"
      title="Quando marcado, o e-mail (NF-e) é obrigatório."
    >
      Receber Notificação Via E-mail
    </label>
    <input
      type="checkbox"
      name="ReceberNotificacaoEmail"
      id="DadosBasicosCliente_ReceberNotificacaoEmail"
      disabled={props.somenteLeitura || !props.permitirAlterarDadosBasicos}
      checked={formik.values?.ReceberNotificacaoEmail === true}
      onChange={(e) => {
        formik.setFieldValue("ReceberNotificacaoEmail", e.target.checked)
      }}
    />
  </div>


  return (
    <>

      <div className="_space-y-1 [&>div>label]:_w-[160px] [&>div>label]:_text-right [&>div>label]:_mb-1 [&>div>label]:_pr-[10px] [&>div>label]:_font-normal">

        {cpfCnpj}

        {nome}

        {formik.values.PessoaJuridica && razaoSocial}

        {email}

        {/* <div className="_grid _grid-cols-[min-content_min-content] lg:_flex ">
        {props.paramTRABALHA_COBRANCA_PIX_PRAZO // 414608 pixPrazo
          && emailPixPrazo 
        }

        {props.paramTRABALHA_COBRANCA_PIX_PRAZO // 414608 pixPrazo
          && atualizarEmailPixPrazo 
        }
        </div> */}

        {!props.foraOrcamento 
         && props.paramTRABALHA_COBRANCA_PIX_PRAZO // 414608 pixPrazo
         && props.tipoOrcamento === 0 && // 414608 -- orcamento venda
         <div className="_grid _grid-cols-[min-content_min-content] lg:_flex ">
          {emailPixPrazo}
          {atualizarEmailPixPrazo}
        </div>
      }

        {dataNascimento}

        <div className="_grid _gap-y-2 _grid-cols-[min-content_min-content] lg:_flex ">

          {telefone}

          {/*493933 {!props.ocultarCelularEContato && celular} */}
          {celular}

        </div>

        {cep}

        <div>

          {logradouro}

          {buttonPesquisaCep}

        </div>

        {numero}

        {complemento}

        {bairro}

        {uf}

        {cidade}

        {referencia}

        <div className="_grid _grid-cols-[min-content_min-content] lg:_flex ">

          {inscricaoEstadual}

          {contribuinte}

        </div>
        <div className="_grid _gap-y-2 _grid-cols-[min-content_min-content] lg:_flex ">
        
          {incricaoSuframa}
          {ClienteAssociado}

        </div>

        <div className="_grid _gap-y-2 _grid-cols-[min-content_min-content] lg:_flex ">

          {segmento}

          {!props.usuarioPermitidoAlterarVendedorRelacionado && (
            vendedorRelacionado
          )}

        </div>

        <div className="_grid _gap-y-2 _grid-cols-[min-content_min-content] lg:_flex">

          {apelido}

         {/* 493933 {!props.ocultarCelularEContato && contato} */}
          {contato}
        </div>

        {props.usaClienteMais?.length > 0 && (
          clienteChatubaMais
        )}

        {receberNotificacaoWhatsapp}

        {receberNotificacaoEmail}

      </div>

    </>
  );
};